// @ts-check
/**
 * @file OfflineIndicator.jsx
 * @location src/components/layout/OfflineIndicator.jsx
 * @role 상단 인디케이터 — Outbox 미전송 건수 + 네트워크 상태.
 *
 *  표시 분기:
 *    online + outbox=[]         → 렌더 안 함 (null)
 *    online + outbox>0          → 「N건 미전송 [재시도]」
 *    offline + outbox=[]        → 「⚠ 오프라인」
 *    offline + outbox>0         → 「⚠ 오프라인 (N건 미전송)」
 *
 *  스타일은 .offline-indicator 클래스로 외부에서 (responsive.css 영역).
 */

/**
 * @param {{ outbox: Array, online: boolean, onRetry: () => void }} props
 */
export function OfflineIndicator({ outbox, online, onRetry }) {
  const count = outbox?.length ?? 0;
  if (online && count === 0) return null;

  const offlinePart = !online ? '⚠ 오프라인' : '';
  const queuePart = count > 0 ? `${count}건 미전송` : '';
  const text = !online && count > 0
    ? `${offlinePart} (${queuePart})`
    : (offlinePart || queuePart);

  return (
    <div className="offline-indicator" role="status">
      <span>{text}</span>
      {count > 0 && online && (
        <button type="button" onClick={onRetry}>재시도</button>
      )}
    </div>
  );
}
